import { conversationsTypes } from './types'

/**
 * Remove an user conversation
 * @param {string} userId
 */
const removeOne = (userId) => ({
  type: conversationsTypes.removeOne,
  userId,
})

/**
 * Remove all conversations
 */
const removeAll = () => ({
  type: conversationsTypes.removeAll,
})

export default {
  removeOne,
  removeAll,
}
